import { createAsyncThunk } from '@reduxjs/toolkit'
import Season from './season-model'
import { delete_season, load_seasons, store_season } from './season-service'

export const LoadSeasonsAsync = createAsyncThunk<any, any>(
  'composer/load/season',
  async (params: { uid: string }) => {
    return await load_seasons(params)
  },
)

export const CreateSeasonAsync = createAsyncThunk<any, any>(
  'composer/create/season',
  async (params: Season) => {
    return await store_season(params)
  },
)

export const DeleteSeasonAsync = createAsyncThunk<any, any>(
  'composer/delete/season',
  async (params) => {
    return await delete_season(params)
  },
)
